var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { appRoutes, useLucidSdk, useSubscribeToBroadcastMessage, } from '@lucidlink/workspacemanagement';
/**
 * Reacts to the `guest-link-logout` broadcast (emitted when a guest session is
 * invalidated) by logging out from the guest client and leaving the guest route.
 * The broadcast reaches every tab, so all of them recover.
 *
 * The broadcast fires once per failed guest query/mutation, so the handler runs
 * multiple times in quick succession. The logout is deduplicated per link, and it
 * is deliberately not awaited before the navigation: it may reject (or stall) when
 * the session is already invalidated server-side, and awaiting it lets a later
 * handler run cancel the in-flight redirect of an earlier one, stranding the router
 * on a blank page.
 *
 * Only a tab currently showing the affected guest link navigates away; other tabs
 * just log out from the guest client.
 */
export const useHandleGuestLinkBroadcast = () => {
    _react_refresh_temp_1();
    const navigate = useNavigate();
    const { lucidSdk } = useLucidSdk();
    const handleGuestLinkLogoutBroadcast = useCallback(async (message) => {
        if (message.type !== 'guest-link-logout') {
            return;
        }
        const { linkId } = message.payload;
        await lucidSdk.guestClient(linkId).logout();
        if (window.location.pathname.startsWith(`/guest/${linkId}`)) {
            await navigate(appRoutes.root());
        }
    }, [lucidSdk, navigate]);
    useSubscribeToBroadcastMessage({
        messageType: 'guest-link-logout',
        callback: handleGuestLinkLogoutBroadcast,
    });
};
_react_refresh_temp_1(useHandleGuestLinkBroadcast, "QLnmjq/hU1Eo1IATJqlm7saBDGw=", false, () => [useNavigate, useLucidSdk, useSubscribeToBroadcastMessage]);
